import React, { createContext, useState, useContext, useEffect } from 'react';

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    systemName: 'Mayta5G ERP',
    theme: 'light', // 'light' o 'black'
    language: 'es',
    currency: 'USD',
    logoUrl: 'https://via.placeholder.com/150'
  });

  const updateGlobalConfig = (newConfig) => {
    setConfig((prev) => ({ ...prev, ...newConfig }));
  };

  // Gestiona la clase global en el body de manera limpia sin forzar inline styles
  useEffect(() => {
    if (config.theme === 'black') {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }, [config.theme]);

  return (
    <ConfigContext.Provider value={{ config, updateGlobalConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig debe ser utilizado estrictamente dentro de un ConfigProvider');
  }
  return context;
};